const styles = (theme) => ({
  dot: {
    borderRadius: '50%',
    width: 10,
    height: 10,
  },
  available: {
    backgroundColor: theme.color.green,
  },
  unavailable: {
    backgroundColor: theme.color.red,
  },
  root: {},
});

export default styles;
